import { render } from "./ForbiddenView.vue?vue&type=template&id=2a23e1ac"
import script from "./ForbiddenView.vue?vue&type=script&lang=js"
export * from "./ForbiddenView.vue?vue&type=script&lang=js"

import "./ForbiddenView.vue?vue&type=style&index=0&id=2a23e1ac&lang=css"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__